import {
  CalendarDays,
  ClipboardCheck,
  FileText,
  Gem,
  Instagram,
  Palette,
  PlayCircle,
  Settings,
  type LucideIcon,
} from "lucide-react";
import type { ResourceItem } from "@/data/content";

/** Icon for a resource type, matched loosely so "Guía", "Guias" and "Guide" agree. */
const ICON_BY_KEYWORD: [string, LucideIcon][] = [
  ["instagram", Instagram],
  ["calendar", CalendarDays],
  ["guia", FileText],
  ["guide", FileText],
  ["ebook", FileText],
  ["plantilla", Palette],
  ["template", Palette],
  ["curso", PlayCircle],
  ["course", PlayCircle],
  ["video", PlayCircle],
  ["herramienta", Settings],
  ["tool", Settings],
  ["pack", Gem],
  ["checklist", ClipboardCheck],
];

function normalize(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export function categoryIcon(type: string): LucideIcon {
  const key = normalize(type);
  return ICON_BY_KEYWORD.find(([keyword]) => key.includes(keyword))?.[1] ?? FileText;
}

export type ResourceCategory = { key: string; label: string; count: number };

/** Categories are the resource types in use, in catalogue order. */
export function resourceCategories(items: ResourceItem[]): ResourceCategory[] {
  const byKey = new Map<string, ResourceCategory>();
  for (const item of items) {
    const key = normalize(item.type);
    if (!key) continue;
    const existing = byKey.get(key);
    if (existing) existing.count += 1;
    else byKey.set(key, { key, label: item.type.trim(), count: 1 });
  }
  return [...byKey.values()];
}

export function categoryKey(item: ResourceItem): string {
  return normalize(item.type);
}

export function matchesSearch(item: ResourceItem, query: string): boolean {
  const q = normalize(query);
  if (!q) return true;
  return normalize(`${item.title} ${item.desc} ${item.type}`).includes(q);
}
